import { create } from "zustand"

type WorkflowRunState = {
  runningWorkflowId: string | null
  runningWorkflowOwnerToken: symbol | null
  setRunningWorkflowId: (id: string, ownerToken?: symbol) => void
  clearRunningWorkflowId: (ownerToken?: symbol) => void
}

export const useWorkflowRunStore = create<WorkflowRunState>((set) => ({
  runningWorkflowId: null,
  runningWorkflowOwnerToken: null,
  setRunningWorkflowId: (id, ownerToken) =>
    set({ runningWorkflowId: id, runningWorkflowOwnerToken: ownerToken ?? null }),
  clearRunningWorkflowId: (ownerToken) =>
    set((state) => {
      // Legacy callers still clear legacy-owned runs, but cannot erase a newer
      // token-owned run. Request-aware callers may only clear their own token.
      if (ownerToken === undefined) {
        if (state.runningWorkflowOwnerToken !== null) return state
      } else if (state.runningWorkflowOwnerToken !== ownerToken) {
        return state
      }
      return { runningWorkflowId: null, runningWorkflowOwnerToken: null }
    }),
}))
